// src/ModalToggle.js
import React from "react";
import "./ModalToggle.css";

const ModalToggle = ({ isChecked, onToggle, disabled, label }) => {
  return (
    <div className={`modal-toggle-container ${disabled ? "disabled" : ""}`}>
      <label className="modal-toggle-label">
        {label && <span className="modal-toggle-text">{label}</span>}
        <input
          type="checkbox"
          checked={isChecked}
          onChange={(e) => onToggle(e.target.checked)}
          className="modal-toggle-checkbox"
          disabled={disabled}
        />
        <span className="modal-toggle-slider"></span>
      </label>
    </div>
  );
};

export default ModalToggle;
